import React from 'react';

const MobileSkeletonLoader = () => {
  return (
    <div className="space-y-6 pb-10 animate-pulse">
      {/* Header Skeleton */}
      <div className="space-y-2 px-2">
        <div className="w-24 h-3 bg-slate-200 rounded-full" />
        <div className="w-48 h-8 bg-slate-200 rounded-2xl" />
      </div>

      {/* Balance Card Skeleton */}
      <div className="w-full h-44 bg-gradient-to-br from-slate-200 via-slate-100 to-slate-200 rounded-[2.5rem] p-6 shadow-sm flex flex-col justify-between" />

      {/* Voice Recorder Skeleton */}
      <div className="w-full h-36 bg-slate-200/80 rounded-[2rem]" />

      {/* Quick Actions Skeleton */}
      <div className="grid grid-cols-2 gap-3">
        <div className="h-24 bg-slate-200 rounded-3xl" />
        <div className="h-24 bg-slate-200 rounded-3xl" />
      </div>

      {/* Categories Skeleton */}
      <div className="space-y-3 pt-2">
        <div className="w-36 h-5 bg-slate-200 rounded-full" />
        <div className="h-16 bg-slate-200 rounded-2xl" />
        <div className="h-16 bg-slate-200 rounded-2xl" />
        <div className="h-16 bg-slate-200 rounded-2xl" />
      </div>
    </div>
  );
};

export default MobileSkeletonLoader;
